import React from "react";
import { Path } from "react-native-svg";

import { IconPathProps } from "../types";

const DoubleChevronRight = ({ lineColor, strokeWidth }: IconPathProps) => (
  <Path
    d="M12 4.5L19.5 12L12 19.5M4.5 4.5L12 12L4.5 19.5"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);

export default DoubleChevronRight;
